// extracted by mini-css-extract-plugin
module.exports = {"popover":"fee_popover__8JQFW","trigger":"fee_trigger___epiP","title":"fee_title__ZNGB7","link":"fee_link__BFtab","vip":"fee_vip__w5tZU","ul":"fee_ul__HIcMJ"};